
import { AuthService } from "@/services/auth-service";
import * as firebase from "firebase/auth";
import Vue from "vue";

export default Vue.extend({
	data() {
		return {
			provider: new firebase.GoogleAuthProvider(),
		};
	},
	methods: {
		async login() {
			let auth = firebase.getAuth();
			await firebase.setPersistence(auth, firebase.browserLocalPersistence);
			let result = await firebase.signInWithPopup(auth, this.provider);
			let id = await (result.user as firebase.User).getIdToken();
			await AuthService.login(id);
		}
	}
});
